<!--
title:标题
hintText:提醒文字
initValue:默认字符串
onlyCharAndNumber:只能输入字母和数字
successCallBack:确认回掉
-->
<template>
  <HScaffold :title="getParams?.title">
    <div class="tHEditorParentDiv">
      <van-field
          maxlength="15"
          v-model="inputText"
          :placeholder="getParams?.hintText??'请输入内容'"
          clearable
          @input="onInput"
      />
      <HButton :disabled="!isCanPress" title="确认" :callback="clickConfirmBtn"/>
    </div>
  </HScaffold>

</template>


<script setup>
  import HScaffold from "@/components/utils/HScaffold.vue";
  import {hr} from "@/components/utils/HRouter.js";
  import HButton from "@/components/utils/HButton.vue";
  const getParams = ref(hr.getRouteParams());

  let inputText = ref(getParams.value['initValue']??'');
  let isCanPress = ref(false);
  let delayTimer = null;
  function onInput(val) {
    if(getParams.value?.onlyCharAndNumber){
      // 只保留小写字母和数字
      let filtered = inputText.value.replace(/[^a-z0-9]/g, '');

      // 如果第一个字符不是小写字母，去掉
      if (filtered && !/^[a-z]/.test(filtered)) {
        filtered = filtered.replace(/^[^a-z]+/, '');
      }
      inputText.value = filtered
    }
    if(delayTimer){
      clearTimeout(delayTimer);
      delayTimer = null;
    }
    delayTimer = setTimeout(()=>{
      //如果是中文会有延迟，这个函数会晚一点拿到值，但是val.data 是一定不会延迟的
      if(inputText.value.trim() === "" || inputText.value  === (getParams.value['initValue']??'')){
        isCanPress.value = false;
      }else{
        isCanPress.value = true;
      }
    },300);
  }

  function clickConfirmBtn(){
    getParams.value?.successCallBack(inputText.value);
  }

  onUnmounted(()=>{
    if(delayTimer){
      clearTimeout(delayTimer);
      delayTimer = null;
    }
  });

</script>


<style scoped>

  .tHEditorParentDiv {
    display: flex;
    flex-direction: column;
    margin-top:10px;
  }

</style>
